import type { App } from 'vue'

import axios from 'axios'
import VueAxios from 'vue-axios'

import { axiosInstances } from '@/http/axios/instances'

export function initVueAxios(app: App<Element>) {
  app.use(VueAxios, axios)
  Object.entries(axiosInstances).forEach(([key, instance]) => {
    app.provide(key, instance)
  })
}
